import type { GSelectMultipleOption } from './type';

import { BlockStack, Box, Checkbox, Popover } from '@shopify/polaris';
import { GActivatorPopover } from '../GActivatorPopover';
import { useTranslation } from 'react-i18next';
import { useToggle } from '~/hooks/useToggle';

interface GSelectMultipleProps {
  placeholder: string;
  activatorContent?: string;
  options: GSelectMultipleOption[];
  selected: string[];
  selectedAllContent?: string;
  onSelect: (value: string) => void;
}

export const GSelectMultiple = ({
  placeholder,
  options,
  selected,
  selectedAllContent,
  onSelect,
}: GSelectMultipleProps) => {
  const { t } = useTranslation();

  const { value: popoverActive, setFalse: closePopover, toggle: togglePopover } = useToggle(false);

  const activatorContent = getActivatorContent();

  return (
    <Popover
      active={popoverActive}
      fullWidth
      activator={
        <GActivatorPopover
          onClick={togglePopover}
          active={popoverActive}
          content={activatorContent}
          textProps={{ tone: selected.length === 0 ? 'disabled' : undefined }}
        />
      }
      onClose={closePopover}
    >
      <Box padding="300">
        <BlockStack gap="300">
          {options.map((option) => (
            <Checkbox
              key={option.value}
              label={option.label}
              checked={option.selected}
              onChange={() => onSelect(option.value)}
            />
          ))}
        </BlockStack>
      </Box>
    </Popover>
  );

  function getActivatorContent() {
    if (selected.length === 0) return placeholder;
    if (selected.length === options.length) return selectedAllContent ?? t('All');

    return options
      .filter((item) => selected.includes(item.value))
      .map((item) => item.label)
      .join(', ');
  }
};
